import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '@/assets/long-insure/nextStep.png'
import _imports_1 from '@/assets/long-insure/rechargeStatus.png'
import _imports_2 from '@/assets/long-insure/rechargeSuccess.png'
import _imports_3 from '@/assets/long-insure/B2B.png'
import _imports_4 from '@/assets/long-insure/upload-add-icon.png'
import _imports_5 from '@/assets/long-insure/code-mh.png'
import _imports_6 from '@/assets/long-insure/we-chat.png'


const _hoisted_1 = { class: "title" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "stepBox" }
const _hoisted_5 = {
  key: 0,
  class: "stepPoint"
}
const _hoisted_6 = {
  key: 1,
  class: "stepPointc"
}
const _hoisted_7 = {
  key: 2,
  class: "next",
  src: _imports_0,
  alt: ""
}
const _hoisted_8 = { class: "text-center backBtn" }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { class: "text-center backBtn" }
const _hoisted_11 = {
  key: 1,
  class: "info-box"
}
const _hoisted_12 = { class: "flex flex-center gap-16 mg-b-12" }
const _hoisted_13 = {
  key: 0,
  class: "gridBox"
}
const _hoisted_14 = { class: "bToB-l" }
const _hoisted_15 = {
  key: 0,
  class: "steptext"
}
const _hoisted_16 = { class: "bankMsgBox" }
const _hoisted_17 = { class: "align-items info-i" }
const _hoisted_18 = { class: "color-darkgrey font-base" }
const _hoisted_19 = { class: "align-items info-i" }
const _hoisted_20 = { class: "color-darkgrey font-base" }
const _hoisted_21 = { class: "align-items info-i" }
const _hoisted_22 = { class: "color-darkgrey font-base" }
const _hoisted_23 = {
  key: 0,
  class: "bToB-r"
}
const _hoisted_24 = { class: "upload-box align-items mg-b-20" }
const _hoisted_25 = {
  key: 0,
  class: "upload point"
}
const _hoisted_26 = {
  key: 0,
  src: _imports_4,
  class: "upload-img",
  alt: ""
}
const _hoisted_27 = {
  key: 1,
  class: "color-lightgray font-mini"
}
const _hoisted_28 = ["src"]
const _hoisted_29 = {
  key: 0,
  class: "priceIptBox"
}
const _hoisted_30 = { class: "priceIpt" }
const _hoisted_31 = {
  key: 1,
  class: "text-red"
}
const _hoisted_32 = {
  key: 2,
  class: "text-red"
}
const _hoisted_33 = { key: 1 }
const _hoisted_34 = {
  key: 0,
  class: "priceIptBox"
}
const _hoisted_35 = { class: "priceIpt" }
const _hoisted_36 = { class: "flex gap-16" }
const _hoisted_37 = { class: "recharge-code flex-no-shrink" }
const _hoisted_38 = {
  key: 0,
  id: "code",
  class: "code"
}
const _hoisted_39 = {
  key: 1,
  src: _imports_5,
  class: "code",
  alt: ""
}
const _hoisted_40 = { class: "pd-t-24 flex flex-colum flex-center" }
const _hoisted_41 = { class: "mg-b-24" }
const _hoisted_42 = { class: "text-FF7642" }
const _hoisted_43 = { class: "font-large" }
const _hoisted_44 = {
  key: 2,
  class: "btn-box align-items justify-end"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_input = _resolveComponent("el-input")!

  return (_openBlock(), _createElementBlock("div", {
    class: "container-popup",
    onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.isCloseType ? '' : _ctx.close()))
  }, [
    _createElementVNode("div", {
      class: "container-c",
      style: _normalizeStyle({ width: _ctx.width }),
      onClick: _cache[8] || (_cache[8] = _withModifiers(() => {}, ["stop"]))
    }, [
      _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.dataTitle), 1),
      _createElementVNode("div", {
        class: "close point",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.close()))
      }, "×"),
      (_ctx.isRechargeOk)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            (_ctx.typeIndex === 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  _createElementVNode("div", _hoisted_4, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.stepList, (item, i) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: i,
                        class: "stepItem"
                      }, [
                        (item.hasNext)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(i + 1), 1))
                          : (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(i + 1), 1)),
                        _createElementVNode("div", null, _toDisplayString(item.text), 1),
                        (item.hasNext)
                          ? (_openBlock(), _createElementBlock("img", _hoisted_7))
                          : _createCommentVNode("", true)
                      ]))
                    }), 128))
                  ]),
                  _cache[11] || (_cache[11] = _createStaticVNode("<div class=\"text-center\" data-v-a6c1ea04><img class=\"statusImg\" src=\"" + _imports_1 + "\" alt=\"\" data-v-a6c1ea04></div><div class=\"text-center text-1989FA text-22\" data-v-a6c1ea04>审核中</div><div class=\"text-center text-9497B1\" data-v-a6c1ea04>工作日9: 00-18:00，3-5分钟到账</div><div class=\"text-center text-9497B1\" data-v-a6c1ea04>周六周日，1-2小时到账</div>", 4)),
                  _createElementVNode("div", _hoisted_8, [
                    _createVNode(_component_el_button, {
                      class: "text-center text-1989FA",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.close()))
                    }, {
                      default: _withCtx(() => _cache[10] || (_cache[10] = [
                        _createTextVNode("返回首页")
                      ])),
                      _: 1
                    })
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.typeIndex === 1)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  _cache[13] || (_cache[13] = _createElementVNode("div", { class: "text-center pd-t-20" }, [
                    _createElementVNode("img", {
                      class: "statusImg",
                      src: _imports_2,
                      alt: ""
                    })
                  ], -1)),
                  _cache[14] || (_cache[14] = _createElementVNode("div", { class: "text-center text-9497B1 pd-t-20" }, "充值成功，详情可查看账单", -1)),
                  _createElementVNode("div", _hoisted_10, [
                    _createVNode(_component_el_button, {
                      class: "text-center text-1989FA",
                      onClick: _ctx.onToBill
                    }, {
                      default: _withCtx(() => _cache[12] || (_cache[12] = [
                        _createTextVNode("查看账单")
                      ])),
                      _: 1
                    }, 8, ["onClick"])
                  ])
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      (!_ctx.isRechargeOk)
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", {
                class: _normalizeClass(['tab-i', 'align-items', 'justify-center', 'point', _ctx.typeIndex == 0 ? 'tab-active' : '']),
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onSwitchTab(0)))
              }, _cache[15] || (_cache[15] = [
                _createElementVNode("img", {
                  src: _imports_3,
                  class: "icon-img",
                  alt: ""
                }, null, -1),
                _createElementVNode("div", { class: "color-darkgrey font-mini" }, "公对公充值", -1)
              ]), 2)
            ]),
            (_ctx.typeIndex == 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                  _createElementVNode("div", _hoisted_14, [
                    (_ctx.dataTitle != '团意保')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_15, "第一步：对公转账"))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_16, [
                      _createElementVNode("div", null, [
                        _cache[19] || (_cache[19] = _createElementVNode("div", { class: "bold mg-b-10" }, "账户信息", -1)),
                        _createElementVNode("div", _hoisted_17, [
                          _cache[16] || (_cache[16] = _createElementVNode("div", { class: "color-grey font-base" }, "企业全称：", -1)),
                          _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.bankName), 1)
                        ]),
                        _createElementVNode("div", _hoisted_19, [
                          _cache[17] || (_cache[17] = _createElementVNode("div", { class: "color-grey font-base" }, "银行账号：", -1)),
                          _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.bankNo), 1)
                        ]),
                        _createElementVNode("div", _hoisted_21, [
                          _cache[18] || (_cache[18] = _createElementVNode("span", { class: "color-grey font-base" }, "开 户 行 ：", -1)),
                          _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.openBank), 1)
                        ])
                      ]),
                      _createVNode(_component_el_button, {
                        type: "primary",
                        size: "mini",
                        class: "w-100",
                        onClick: _ctx.copyText
                      }, {
                        default: _withCtx(() => _cache[20] || (_cache[20] = [
                          _createTextVNode("复制信息")
                        ])),
                        _: 1
                      }, 8, ["onClick"])
                    ])
                  ]),
                  (_ctx.dataTitle != '团意保')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                        _cache[23] || (_cache[23] = _createElementVNode("div", { class: "steptext" }, "第二步：上传付款回执及充值金额", -1)),
                        _cache[24] || (_cache[24] = _createElementVNode("div", { class: "text-9497B1" }, "上传凭证", -1)),
                        _createElementVNode("div", _hoisted_24, [
                          (_ctx.dataTitle != '团意保')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                                (!_ctx.fileValue)
                                  ? (_openBlock(), _createElementBlock("img", _hoisted_26))
                                  : _createCommentVNode("", true),
                                (!_ctx.fileValue)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_27, "点击上传付款回执，支持jpg、png "))
                                  : _createCommentVNode("", true),
                                (_ctx.fileValue)
                                  ? (_openBlock(), _createElementBlock("img", {
                                      key: 2,
                                      src: _ctx.fileValue,
                                      class: "upload-preview-img",
                                      alt: ""
                                    }, null, 8, _hoisted_28))
                                  : _createCommentVNode("", true),
                                _createElementVNode("input", {
                                  type: "file",
                                  ref: "fileInput",
                                  onChange: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.handleFileUpload && _ctx.handleFileUpload(...args))),
                                  name: "image",
                                  accept: ".bmp,.jpg,.png,.tif,.gif,.pcx,.tga,.exif,.fpx,.svg,.psd,.cdr,.pcd,.dxf,.ufo,.eps,.ai,.raw,.WMF,.webp,.jpeg",
                                  class: "fileInput"
                                }, null, 544)
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        _cache[25] || (_cache[25] = _createElementVNode("div", { class: "text-9497B1 mg-b-10" }, "请填写正确的充值金额，如分开充值，需分批次申请", -1)),
                        (_ctx.dataTitle != '团意保')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                              _cache[22] || (_cache[22] = _createElementVNode("div", { class: "title bold mg-b-20" }, "充值金额（元）", -1)),
                              _createElementVNode("div", _hoisted_30, [
                                _cache[21] || (_cache[21] = _createElementVNode("div", { class: "font-large bold" }, "¥", -1)),
                                _createVNode(_component_el_input, {
                                  class: _normalizeClass({ 'ipt':true, 'text-red':_ctx.ocrNum!==_ctx.num}),
                                  modelValue: _ctx.num,
                                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.num) = $event)),
                                  onInput: _ctx.onNum,
                                  placeholder: "请输入充值金额"
                                }, null, 8, ["class", "modelValue", "onInput"])
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.isRepeat)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_31, "您已上传提交过相同金额的回执单"))
                          : _createCommentVNode("", true),
                        (!_ctx.isRepeat && _ctx.ocrNum!==_ctx.num)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_32, "请输入和回执单一致的金额"))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            (_ctx.typeIndex == 1)
              ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                  _createElementVNode("div", null, [
                    _cache[28] || (_cache[28] = _createElementVNode("div", { class: "text-9497B1 mg-b-10" }, "请填写正确的充值金额，如分开充值，需分批次申请", -1)),
                    (_ctx.dataTitle != '团意保')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                          _cache[27] || (_cache[27] = _createElementVNode("div", { class: "title bold mg-b-20" }, "充值金额（元）", -1)),
                          _createElementVNode("div", _hoisted_35, [
                            _cache[26] || (_cache[26] = _createElementVNode("div", { class: "font-large bold" }, "¥", -1)),
                            _createVNode(_component_el_input, {
                              class: "ipt",
                              modelValue: _ctx.num,
                              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.num) = $event)),
                              onInput: _ctx.onNum,
                              placeholder: "请输入充值金额"
                            }, null, 8, ["modelValue", "onInput"])
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_36, [
                    _createElementVNode("div", _hoisted_37, [
                      (_ctx.num)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_38))
                        : _createCommentVNode("", true),
                      (!_ctx.num)
                        ? (_openBlock(), _createElementBlock("img", _hoisted_39))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_40, [
                      _cache[31] || (_cache[31] = _createElementVNode("div", { class: "mg-b-10" }, "在线支付", -1)),
                      _cache[32] || (_cache[32] = _createElementVNode("div", {
                        class: _normalizeClass(['tab-i', 'align-items', 'justify-center', 'point', 'mg-b-24'])
                      }, [
                        _createElementVNode("img", {
                          src: _imports_6,
                          class: "icon-img",
                          alt: ""
                        }),
                        _createElementVNode("div", { class: "color-darkgrey font-mini" }, "微信充值")
                      ], -1)),
                      _createElementVNode("div", _hoisted_41, [
                        _cache[30] || (_cache[30] = _createTextVNode("应付金额")),
                        _createElementVNode("span", _hoisted_42, [
                          _cache[29] || (_cache[29] = _createTextVNode("￥")),
                          _createElementVNode("span", _hoisted_43, _toDisplayString(_ctx.num || '0.0'), 1)
                        ])
                      ]),
                      _cache[33] || (_cache[33] = _createElementVNode("div", null, " 打开手机端微信 ", -1)),
                      _cache[34] || (_cache[34] = _createElementVNode("div", null, " 扫一扫继续付款 ", -1))
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      (_ctx.typeIndex == 0 && !_ctx.isRechargeOk)
        ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
            _createVNode(_component_el_button, {
              size: "large",
              class: "btn",
              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.close()))
            }, {
              default: _withCtx(() => _cache[35] || (_cache[35] = [
                _createTextVNode("取消")
              ])),
              _: 1
            }),
            _createVNode(_component_el_button, {
              size: "large",
              type: "primary",
              class: "btn",
              onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.determine()))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.dataTitle != '团意保' ? '提交' :
                            '确定'), 1)
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true)
    ], 4)
  ]))
}